import axios from "axios";
import routes from "../../app/routes";

const prepareFormDataForSend = (values) => {
  let formData = {
    enterprise_id: values.enterprise,
    enterprise_team_id: values.team,
  };
  return formData;
};

const update = (id, values, afterSave) => {
  axios
    .patch(routes.api.file_imports.update(id), {
      file_import: { ...prepareFormDataForSend(values) },
    })
    .then((resp) => {
      afterSave();
    })
    .catch(function (error, data) {
      swal(error.response.data.error);
    });
};

const saveForm = (values, initialFormValues, afterSave) => {
  update(initialFormValues.id, values, afterSave);
};

export default saveForm;
